module.exports = __webpack_public_path__ + "img/butts-mehre.8a862b45.jpg";